let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b544F")).then(() => parcelRequire('8JOK1'));